import { Flex } from '@chakra-ui/react';

import { Info } from 'assets/assetsV1/iconComponents';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

export const PerformanceFilterWarning = ({ children }) => (
  <Flex
    borderBottomColor="border.CFD7DF"
    borderBottomWidth="1px"
    px={2}
    pt={3}
    pb={4}
    mx={3}
    alignItems="center"
    gap={2}
  >
    <Info boxSize="24px" />
    <TextBodyMedium>{children}</TextBodyMedium>
  </Flex>
);
